import Collection from '@/components/Collection'
import access from '../access'

export default {

  'epp_log.collection':{
    path: '/admin/epp-logs',
    name: 'epp_log.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listEppLogs",
      entity: "epp_log",
      cols: [
        {label: "ID", sort: "id", field: "id"},
        {label: "Time", sort: "timestamp", field: "timestamp", timestamp: "default" },
        {label: "Registrar", sort: "registrar_id", uuid: "registrar_id"}, // @maybe link to page
        {label: "Session", sort: "session", uuid: "session"},
        {label: "Command", sort: "command", field: "command"},
        {label: "Subject", sort: "subject", field: "subject"},
        {label: "CLTRID", sort: "cltrid", field: "client_transaction_id"},
        {label: "IP", field: "ip_address"},
        {
          label: "Request",
          component: "ModalDetail",
          componentProps: (row) => {
            return {
              title: "Request",
              payload: '<pre>'+h2t(row.request)+'</pre>'
            }
          }
        },
        {
          label: "Response",
          component: "ModalDetail",
          componentProps: (row) => {
            return {
              title: "Response",
              payload: '<pre>'+h2t(row.response)+'</pre>'
            }
          }
        },
      ],
    },
    meta: {
      access: access.chain(access.admin, function(user) {
        return user.epp_log_enabled === true
      }),
      title: "EPP protocol logs",
      side_menu: { label: "EPP Logs",  icon: "database", weight: 100 },
    },
  },

}

// https://stackoverflow.com/a/6234804
function h2t(h) {
    return h
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
}



// WEBPACK FOOTER //
// ./src/routes/modules/epp-log.js